import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import * as Icons from "lucide-react";
import { ACHIEVEMENTS, getUnlockedIds } from "@/lib/achievements";

export default function AchievementsDialog({ open, onOpenChange }) {
  const unlocked = new Set(getUnlockedIds());
  const total = ACHIEVEMENTS.length;
  const count = unlocked.size;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="achievements-dialog"
        className="max-w-2xl max-h-[85vh] overflow-y-auto bg-black/80 backdrop-blur-2xl border border-white/10 text-white rounded-none"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-3xl tracking-tighter flex items-center gap-3">
            <Icons.Award size={20} className="text-[#FFD400]" />
            ACHIEVEMENTS
            <span className="ml-auto text-sm text-white/60 tracking-[0.3em]">
              {count} / {total}
            </span>
          </DialogTitle>
        </DialogHeader>

        <div className="text-[10px] tracking-[0.3em] text-white/50 mt-1">
          COLLECT THEM ALL · UNLOCK SKINS + BADGES
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3">
          {ACHIEVEMENTS.map((a) => {
            const Icon = Icons[a.icon] || Icons.Star;
            const done = unlocked.has(a.id);
            return (
              <div
                key={a.id}
                data-testid={`achievement-${a.id}`}
                className="flex items-center gap-3 px-4 py-3 border transition-colors"
                style={{
                  borderColor: done ? "#FFD400" : "rgba(255,255,255,0.1)",
                  background: done ? "rgba(255,212,0,0.06)" : "transparent",
                  boxShadow: done ? "0 0 14px rgba(255,212,0,0.15)" : "none",
                }}
              >
                <div
                  className="w-10 h-10 shrink-0 flex items-center justify-center border"
                  style={{
                    borderColor: done ? "#FFD400" : "rgba(255,255,255,0.15)",
                    color: done ? "#FFD400" : "rgba(255,255,255,0.35)",
                  }}
                >
                  <Icon size={18} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className={`text-xs tracking-[0.3em] font-bold ${done ? "text-[#FFD400]" : "text-white/50"}`}>
                    {a.name}
                  </div>
                  <div className="text-[10px] tracking-[0.2em] text-white/40 mt-0.5">
                    {done ? "UNLOCKED" : a.description}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
